import { Emitter } from 'lape';
import mergeDeepRight from 'ramda/es/mergeDeepRight';
import stateUi from '@state/ui';
import { getSelectedElement, getSelectedModifier } from '@src/selector';
export function uuid() {
    // return ('' + 1e7 + -1e3 + -4e3 + -8e3 + -1e11).replace(/[10]/g, function() {
    return ('' + 1e7).replace(/[10]/g, function () {
        return (0 | (Math.random() * 16)).toString(16);
    });
}
export const connectDevTools = (state) => {
    if (!window.__REDUX_DEVTOOLS_EXTENSION__) {
        return;
    }
    const config = {
        features: {
            pause: false,
            lock: false,
            persist: false,
            export: false,
            import: false,
            jump: false,
            skip: false,
            reorder: false,
            dispatch: false,
            test: false,
        },
    };
    const devTools = window.__REDUX_DEVTOOLS_EXTENSION__.connect(config);
    devTools.init(state);
    Emitter.listenSetEvents(() => {
        devTools.send('State changed', state);
    });
};
export const mergeElements = (a, b) => {
    return Object.assign(Object.assign({}, a), { root: Object.assign(Object.assign({}, mergeDeepRight(a.root, b)), { order: b.order }) });
};
export const getSelectedNode = () => {
    if (!stateUi.selectedNode) {
        return null;
    }
    const selectedElement = getSelectedElement();
    const modifier = getSelectedModifier();
    const elementState = stateUi.stateManager;
    const mergedElement = modifier ? mergeElements(selectedElement, selectedElement.modifiers[modifier]) : selectedElement;
    const child = mergedElement.root.children[stateUi.selectedNode.id];
    const node = elementState ? mergeDeepRight(child, child.states[elementState]) : child;
    return node;
};
